module.exports = __webpack_public_path__ + "static/media/TG.e0f44835.svg";